import React from 'react';
import {Box, Typography, styled} from "@mui/material";

const Root = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.grey[50],
  borderLeft: `3px solid ${theme.palette.warning.main}`,
  fontSize: '0.875rem',
  lineHeight: 1.5,
}));

const CancellationPolicy: React.FC = () => {
  return (
    <Root>
      <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
        Cancellation Policy
      </Typography>
      <Typography variant="body2" component="div">
        <ul style={{ margin: 0, paddingLeft: '1.2em', listStyleType: 'disc' }}>
          <li>Same-day bookings and unused spaces are non-refundable.</li>
          <li>Cancel up to 24 hours before your booking for a full refund.</li>
          <li>No exceptions.</li>
        </ul>
      </Typography>
    </Root>
  );
};

export default CancellationPolicy;
